import type { ProjectMember } from '../auth/types';

const FULL_SENSITIVE_PERSONNEL_ROLE_IDS = new Set([
  'owner',
  'stage-manager',
  'production-manager',
  'assistant-stage-manager',
]);

export function canReadAllSensitivePersonnelFromRoleId(
  roleId: string | null | undefined
): boolean {
  return typeof roleId === 'string' && FULL_SENSITIVE_PERSONNEL_ROLE_IDS.has(roleId);
}

export function canReadAllSensitivePersonnelFromMember(
  member: Pick<ProjectMember, 'roleId'> | null | undefined
): boolean {
  return canReadAllSensitivePersonnelFromRoleId(member?.roleId);
}
